<div class="collapsible-section" [ngClass]="{'expanded': expanded}">
    <button type="button" class="collapsible-section-header" (click)="toggle()" [dataHook]="dataHook"
        [attr.aria-expanded]="expanded">
        <div class="collapsible-section-heading">
            <div class="collapsible-section-title">{{ title | translate }}</div>
            <div class="collapsible-section-meta">
                <span class="collapsible-section-subtitle" *ngIf="subtitle">{{ subtitle | translate }}</span>
                <ng-content select="[summary]"></ng-content>
            </div>
        </div>
        <ng-icon class="collapsible-section-chevron" [name]="'heroChevronDownSolid'"></ng-icon>
    </button>
    <div class="collapsible-section-body" *ngIf="expanded">
        <ng-content></ng-content>
    </div>
</div>
